<template>
  <div>
    <div class="display-1 font-weight-normal mb-6 text-center">Por favor, selecione a forma como será feita a setorização</div>
    <v-row class="mx-auto">
      <v-col cols="12">
        <select-algoritmos-setorizacoes
          id="algoritmo-setorizacao"
          label="Regra de setorização"
          type="outlined"
          :value="items.algoritmo ? items.algoritmo.id : null"
          @algoritmoSelecionado="algoritmoSelecionado"
        />
      </v-col>
      <v-col v-if="algoritmo" cols="12">
        <div class="display-1 font-weight-normal mb-6 text-center">
          Exemplo de setorização da área de concessão usando a regra
        </div>
        <v-img
          v-if="algoritmo.descricao"
          class="align-end white--text"
          height="300px"
          :src="require(`@/assets/setorizacoes/${algoritmo.classe}.png`)"
        >
          <v-card-title style="color: #424242">
            {{ algoritmo.descricao }}
          </v-card-title>
        </v-img>
      </v-col>
      <v-col v-if="algoritmo" cols="12">
        <div class="display-1 font-weight-normal mb-6 text-center">Parâmetros de configuração da regra de setorização</div>
        <v-form class="mt-5">
          <component
            :is="formAlgoritmoConfig"
            id="algoritmo-config"
            :month="month"
            :bdgdVersion="bdgdVersion"
            :algoritmoConfig="items.algoritmo_config"
            @algoritmoConfigAtualizado="algoritmoConfigAtualizado"
          />
        </v-form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import components from '@/components/setorizacoes/forms/components.js';

  export default {
    name: 'SecondTabContent',
    components: {
      ...components,
      SelectAlgoritmosSetorizacoes: () => import('@/components/general/SelectAlgoritmosSetorizacoes.vue')
    },
    props: {
      month: {
        type: String
      },
      bdgdVersion: {
        type: Number
      },
      items: {
        type: Object
      }
    },
    data() {
      return {
        algoritmo: {
          id: '',
          classe: null,
          descricao: null,
          nome: null
        },
        algoritmoConfig: {}
      };
    },
    computed: {
      formAlgoritmoConfig() {
        return this.algoritmo && this.algoritmo.classe ? `Form${this.algoritmo.classe}Config` : null;
      }
    },
    mounted() {
      if (this.items) this.fillInputs();
    },
    methods: {
      emitEventDataUpdated() {
        this.$emit('data:updated', {
          algoritmo: this.algoritmo,
          algoritmoConfig: this.algoritmoConfig
        });
      },
      algoritmoSelecionado(event) {
        this.algoritmo = event;
      },
      algoritmoConfigAtualizado(event) {
        this.algoritmoConfig = event;
      },
      fillInputs() {
        this.algoritmoSelecionado(this.items.algoritmo);
        this.algoritmoConfigAtualizado(this.items.algoritmo_config);
      }
    },
    watch: {
      algoritmo() {
        this.emitEventDataUpdated();
      },
      algoritmoConfig() {
        this.emitEventDataUpdated();
      }
    }
  };
</script>
